/**
 * A count with its noun, in the number that reads correctly.
 *
 * The console speaks in whole sentences, and "Write 1 key states?" is the kind
 * of thing that makes a careful reader distrust the rest of the screen. The
 * plural is spelled out rather than derived, because English will not have it
 * any other way: one entry, two entries; one key state, two key states.
 */
export const countOf = (count: number, singular: string, plural: string): string =>
  `${count} ${count === 1 ? singular : plural}`;

/** Which pronoun a count takes when the sentence refers back to it. */
export const pronounFor = (count: number): string => (count === 1 ? 'it' : 'them');

/** The verb a count takes: one state is, two states are. */
export const verbFor = (count: number): string => (count === 1 ? 'is' : 'are');
